var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trash-cell"},[(_vm.child && _vm.child.volume && _vm.child.volume.trash)?[_vm._v(" "+_vm._s(_vm.child.volume.trash)+"% ")]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }